import { getUrlPrefix } from '../locales'

// this prefix is all urls, and so put the lang prefix after and the rest of the url
const PREFIX = '/_/fallback'

const baseURL = process.client
  ? ''
  : process.env.NUXT_AXIOS_BASE_URL || 'http://varnish_plus:8100'

export function langFallback$Fetch<T>(langCode: string, url: string, init?) {
  const langPrefix = getUrlPrefix(langCode)
  const fetchOptions = {
    timeout: 10000,
    baseURL,
    ...init,
  }
  return $fetch<T>(`${PREFIX}${langPrefix}${url}`, fetchOptions)
}

export function langFallbackFetch(
  langCode: string,
  url: string,
  init?: RequestInit,
) {
  const langPrefix = getUrlPrefix(langCode)
  return fetch(`${PREFIX}${langPrefix}${url}`, init)
}

export function getLangFallbackUrl(langCode: string, url: string) {
  const langPrefix = getUrlPrefix(langCode)
  return `${PREFIX}${langPrefix}${url}`
}

export function getDomainName() {
  return window.location.hostname
}
